export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13228.4bba33fb.jpg";